<div class="invoice-approve-page">
  <div v-if="pageState === 'loading'" class="invoice-approve-status">
    <p>Loading invoice...</p>
  </div>

  <div v-else-if="pageState === 'error'" class="invoice-approve-status">
    <h1>Unable to load invoice</h1>
    <p>{{ errorMessage }}</p>
  </div>

  <div v-else-if="pageState === 'success'" class="main-container">
    <div class="ui middle aligned center aligned grid">
      <div class="sixteen wide column ">
        <img src="../../../assets/img/icn_success_outline.svg" alt="success-icon">
      </div>
      <div class="sixteen wide column">
        <h1>Thank You!</h1>
        <p>You have successfully approved invoice {{ invoiceNumber }} for {{ currency(invoiceTotal, '$', 2, { decimalSeperator: ','})}}.</p>
        <p>You can close this window</p>
      </div>
    </div>
  </div>

  <quote-preview
    v-else-if="pageState === 'review'"
    :parent_quote="invoice"
    :parent_quote_items="invoiceItems"
    :parent_contact="contact"
    :parent_settings="settings"
    :read_only="true"
    :public_accept="true"
    document_kind="invoice"
    @accepted="onApproved">
  </quote-preview>
</div>
